
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class PriceListGrid extends Serenity.EntityGrid<PriceListRow, any> {
        protected getColumnsKey() { return 'OMS.PriceList'; }
        protected getDialogType() { return PriceListDialog; }
        protected getIdProperty() { return PriceListRow.idProperty; }
        protected getInsertPermission() { return PriceListRow.insertPermission; }
        protected getLocalTextPrefix() { return PriceListRow.localTextPrefix; }
        protected getService() { return PriceListService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}